import { Dialog } from '@headlessui/react';
import { useDialog } from '@ecdlink/core';
import { ActionModal, DialogPosition } from '@ecdlink/ui';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { ChildBasicInfoModel } from '@schemas/child/child-registration/child-basic-info';
import { ChildBasicInfo } from './child-basic-info/child-basic-info';
import { CaregiverLink } from './caregiver-link/caregiver-link';
import { StepViewer } from '../../../components/step-viewer/step-viewer';
import { Step } from '../../../components/step-viewer/components/step';
import { useOnlineStatus } from '@hooks/useOnlineStatus';

interface PractitionerChildRegistrationProps {
  isFromTraineeOnboarding?: boolean;
}

export const PractitionerChildRegistration: React.FC<
  PractitionerChildRegistrationProps
> = ({ isFromTraineeOnboarding }) => {
  const dialog = useDialog();
  const history = useHistory();
  const { isOnline } = useOnlineStatus();
  const [childDetails, setChildDetails] = useState<ChildBasicInfoModel>();

  const onBasicChildInfoSubmitted = async (
    basicDetails: ChildBasicInfoModel
  ) => {
    setChildDetails(basicDetails);
  };

  const exitRegistrationPrompt = () => {
    dialog({
      position: DialogPosition.Middle,
      render: (onSubmit, onCancel) => (
        <Dialog.Panel>
          <ActionModal
            icon={'InformationCircleIcon'}
            iconColor="alertMain"
            iconBorderColor="alertBg"
            importantText={`Are you sure you want to exit now?`}
            detailText={'If you exit now you will lose your progress.'}
            actionButtons={[
              {
                text: 'Exit',
                textColour: 'white',
                colour: 'primary',
                type: 'filled',
                onClick: () => {
                  onSubmit();
                  history.goBack();
                },
                leadingIcon: 'ArrowLeftIcon',
              },
              {
                text: 'Close',
                textColour: 'primary',
                colour: 'primary',
                type: 'outlined',
                onClick: () => onCancel(),
                leadingIcon: 'PencilIcon',
              },
            ]}
          />
        </Dialog.Panel>
      ),
    });
  };

  const onNewChild = () => {
    setChildDetails(undefined);
  };

  return (
    <StepViewer
      title="Add a child"
      onBack={() => {
        history.goBack();
      }}
      activeStep={1}
      onClose={exitRegistrationPrompt}
      isOnline={isOnline}
      showOfflineCard={false}
    >
      <Step stepKey={1} viewBannerWapper={true}>
        <div className="flex h-full w-full flex-col bg-white p-4">
          <ChildBasicInfo onSubmit={onBasicChildInfoSubmitted} />
          {childDetails && (
            <CaregiverLink
              onNewChild={onNewChild}
              childDetails={childDetails}
              isFromTraineeOnboarding={isFromTraineeOnboarding}
            />
          )}
        </div>
      </Step>
    </StepViewer>
  );
};
